/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessageCode = createReactComponent("message-code", "IconMessageCode", [
  ["path", { d: "M8 9h8", key: "svg-0" }],
  ["path", { d: "M8 13h6", key: "svg-1" }],
  [
    "path",
    {
      d: "M11.012 19.193l-3.012 1.807v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6",
      key: "svg-2"
    }
  ],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-3" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-4" }]
]);

export { IconMessageCode as default };
//# sourceMappingURL=IconMessageCode.js.map
